import { create } from "zustand";

/**
 * Store that lets the 3D viewer request opening the configuration menu for a
 * specific part (e.g. ⌘/Ctrl-clicking an addable without dragging it). The
 * viewer only knows the part's `sourceOptionUuid`; the host app subscribes and
 * decides how to surface the matching editor. `requestSeq` increments on every
 * request so subscribers re-fire even when the same part is clicked twice.
 * The editor that surfaces the part clears the request, so it is handled once
 * and not replayed when the editor list mounts again later.
 */
interface PartMenuState {
  /** The sourceOptionUuid of the part whose menu was requested, or null. */
  requestedOptionUuid: string | null;
  /** Monotonic counter incremented on every request. */
  requestSeq: number;
  /** Request opening the menu for the part with the given sourceOptionUuid. */
  requestPartMenu: (optionUuid: string) => void;
  /** Mark the request for the given part as handled. */
  clearPartMenuRequest: (optionUuid: string) => void;
}

export const usePartMenuStore = create<PartMenuState>((set) => ({
  requestedOptionUuid: null,
  requestSeq: 0,

  requestPartMenu: (optionUuid: string) => {
    set((state) => ({
      requestedOptionUuid: optionUuid,
      requestSeq: state.requestSeq + 1,
    }));
  },

  clearPartMenuRequest: (optionUuid: string) => {
    set((state) =>
      state.requestedOptionUuid === optionUuid
        ? { requestedOptionUuid: null }
        : state,
    );
  },
}));
